import styled from 'styled-components';
import React from 'react';
import {WithSidebarContext} from '../../SidebarContext';
import {ScrollBar} from '../../shared-components/mixin/scroll/scrollBar';

export const MainContentWrapper = styled(ScrollBar)`
    padding: var(--main-grid-padding);
    transition: width var(--sidebar-animation-speed) ease-in-out;
    grid-area: body;
    overflow: auto;

    ${({sidebarOpen, sidebarClosing}) => {
        if (sidebarOpen && !sidebarClosing) {
            return `
                max-width: 100vw;
                width: 100%;
            `;
        } else {
            return `
                width: 100%;
            `;
        }
    }}
`;

const MainContent = ({children}) => {
    return (
        <WithSidebarContext>
            {({sidebarOpen, sidebarClosing}) => (
                <MainContentWrapper sidebarOpen={sidebarOpen} sidebarClosing={sidebarClosing}>
                    {children}
                </MainContentWrapper>
            )}
        </WithSidebarContext>
    );
};

const mainContentBlockDirection = (direction) => {
    if (direction == 'horz')
        return `
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    `;
    else return ``;
};

const MainContentBlock = styled.div`
    ${({direction}) => mainContentBlockDirection(direction)};
    &:not(:last-of-type) {
        margin-bottom: ${({tight}) => (tight ? '0rem' : '2rem')};
    }
`;

const MainContentTitle = styled.h1`
    color: var(--title-text-200);
    font-size: var(--text-size-large);
    margin-bottom: 1rem;
    font-weight: 800;
`;
const MainContentSubTitle = styled.h2`
    color: var(--title-text-200);
    font-size: var(--text-size-medium);
    font-weight: 800;
    margin-bottom: 0.5rem;
`;

MainContent.Wrapper = MainContentWrapper;
MainContent.Title = MainContentTitle;
MainContent.SubTitle = MainContentSubTitle;
MainContent.Block = MainContentBlock;
export default MainContent;
export {MainContentTitle, MainContentBlock};
